import { useSelector } from 'react-redux';

import { Store } from '@/shared/store';

export const useAssetBalance = (assetName: string) => {
    const {
        balance = 0,
        address,
        assets,
    } = useSelector((state: Store) => ({
        balance: state?.supplies?.fund?.balances[assetName],
        address: state?.supplies?.fund?.addresses[assetName],
        assets: state.supplies.assetsToSupply,
    }));

    const asset = assets.find((asset) => asset.address === address);
    const decimals = asset ? asset.decimals : 18;

    return { balance, address, decimals };
};
